import React from 'react';
import { ComponentProps } from './ComponentProps';
import { useBiClickLogger } from '../hooks/useBiClickLogger';

const BiSpan: React.FC<Partial<ComponentProps>> = ({
  biData,
  innerRef,
  stopPropagation,
  ...props
}) => {
  const { setTrackingRef } = useBiClickLogger(biData, stopPropagation);
  return (
    <span
      {...props}
      ref={node => {
        setTrackingRef(node);
        innerRef && innerRef(node);
      }}
    />
  );
};
BiSpan.displayName = 'BiSpan';

export default BiSpan;
